import {
  Button,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import FileCopyIcon from "@material-ui/icons/FileCopy"
import dayjs from "dayjs"
import PropTypes from "prop-types"
import React, { useContext } from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { useHistory } from "react-router-dom"
import HoverText from "~/components/Common/HoverText"
import PaperListRow from "~/components/Common/PaperListRow"
import AppContext from "~/contexts/App"
import Box from "../../Common/Box"
import useStyles from "./styles"

const ApiKey = ({ apiKey, client }) => {
  //provided is an object used to move the lessons inside courses
  const classes = useStyles()
  const theme = useTheme()
  const history = useHistory()
  const { openDialog, openSnackBar } = useContext(AppContext)

  const openEditKeysDialog = () => {
    let data = {
      apiKey: apiKey,
      client: client,
      action: "edit",
    }
    openDialog("EditClientKeysDialog", data)
  }

  const xsDown = useMediaQuery(theme.breakpoints.down("xs"))
  if (!xsDown) {
    return (
      <PaperListRow componentWidth={"100%"}>
        <Grid container spacing={0} className={classes.container}>
          <Grid
            item
            md={9}
            xs={12}
            className={classes.titleContainer}
            // onClick={() => history.push(`/lessons/${lesson.lesson_id}`)}
          >
            <HoverText
              data={apiKey?.name}
              size={30}
              variant="h3"
              className={classes.nameText}
            />
          </Grid>
          <Grid item md={1} xs={12} className={classes.titleContainer}>
            <Typography>
              {dayjs(apiKey?.updated)?.format("M/D/YYYY")}
            </Typography>
          </Grid>
          <Grid item md={1} xs={12} className={classes.titleContainer}>
            <Button onClick={openEditKeysDialog}>Edit</Button>
          </Grid>

          <Grid item md={1} xs={12} className={classes.titleContainer}>
            <CopyToClipboard
              text={apiKey?.api_key}
              onCopy={() => openSnackBar({ message: "Link copied" })}
              options={{ format: "text/plain" }}
            >
              <Box
                width="100%"
                marginBottom="8px"
                display="flex"
                alignItems="center"
                style={{ cursor: "pointer" }}
              >
                <FileCopyIcon
                  variant="contained"
                  // disableElevation
                  style={{ marginLeft: "10px", width: "14px" }}
                />
              </Box>
            </CopyToClipboard>
          </Grid>
        </Grid>
      </PaperListRow>
    )
  } else {
    return (
      <PaperListRow componentWidth={"100%"}>
        <Grid container spacing={0} className={classes.container}>
          <Grid item md={3} xs={6} className={classes.titleContainer}>
            <HoverText
              data={apiKey?.name}
              size={30}
              variant="h3"
              className={classes.nameText}
            />
          </Grid>
          <Grid item md={1} xs={6} className={classes.titleContainer}>
            <Typography>
              {dayjs(apiKey?.updated)?.format("M/D/YYYY")}
            </Typography>
          </Grid>

          <Grid item md={1} xs={6} className={classes.titleContainer}>
            <Button onClick={openEditKeysDialog}>Edit</Button>
          </Grid>
          <Grid item md={1} xs={6} className={classes.titleContainer}>
            <CopyToClipboard
              text={apiKey?.api_key}
              onCopy={() => openSnackBar({ message: "API Key copied" })}
              options={{ format: "text/plain" }}
            >
              <Box
                width="100%"
                marginBottom="8px"
                display="flex"
                alignItems="center"
                style={{ cursor: "pointer" }}
              >
                <FileCopyIcon
                  variant="contained"
                  // disableElevation
                  style={{ marginLeft: "10px", width: "14px" }}
                />
              </Box>
            </CopyToClipboard>
          </Grid>
        </Grid>
      </PaperListRow>
    )
  }
}

ApiKey.propTypes = {
  apiKey: PropTypes.object,
  client: PropTypes.object,
  provided: PropTypes.object,
}

export default ApiKey
